var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Interface-Dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu-Symbol",
    transform: "translate(0.000000, -0.000000)",
    strokeWidth: 1.5,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interface-Dashboard",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42857143,9.42857143 C8.98085618,9.42857143 9.42857143,9.87628668 9.42857143,10.4285714 L9.42857143,21 C9.42857143,21.5522847 8.98085618,22 8.42857143,22 L1,22 C0.44771525,22 4.61014089e-13,21.5522847 4.60076421e-13,21 L4.60076421e-13,10.4285714 C4.59897764e-13,9.87628668 0.44771525,9.42857143 1,9.42857143 L8.42857143,9.42857143 Z M21,15.7142857 C21.5522847,15.7142857 22,16.162001 22,16.7142857 L22,21 C22,21.5522847 21.5522847,22 21,22 L13.5714286,22 C13.0191438,22 12.5714286,21.5522847 12.5714286,21 L12.5714286,16.7142857 C12.5714286,16.162001 13.0191438,15.7142857 13.5714286,15.7142857 L21,15.7142857 Z M21,0 C21.5522847,-1.08250786e-15 22,0.44771525 22,1 L22,11.5714286 C22,12.1237133 21.5522847,12.5714286 21,12.5714286 L13.5714286,12.5714286 C13.0191438,12.5714286 12.5714286,12.1237133 12.5714286,11.5714286 L12.5714286,1 C12.5714286,0.44771525 13.0191438,1.01453063e-16 13.5714286,0 L21,0 Z M8.42857143,-4.4408921e-16 C8.98085618,-1.52659707e-15 9.42857143,0.44771525 9.42857143,1 L9.42857143,5.28571429 C9.42857143,5.83799904 8.98085618,6.28571429 8.42857143,6.28571429 L1,6.28571429 C0.44771525,6.28571429 4.60144057e-13,5.83799904 4.60076421e-13,5.28571429 L4.60076421e-13,1 C4.60008786e-13,0.44771525 0.44771525,-3.42636147e-16 1,-4.4408921e-16 L8.42857143,-4.4408921e-16 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.8460be7d94015ae99467794abeef61de.svg";
export { ForwardRef as ReactComponent };